/** Light/dark theme, persisted in localStorage and applied via the <html data-theme> attribute. */
export type Theme = "light" | "dark";

export function getTheme(): Theme {
  return localStorage.getItem("vq-theme") === "dark" ? "dark" : "light";
}

export function applyTheme(t: Theme): void {
  document.documentElement.dataset.theme = t;
  localStorage.setItem("vq-theme", t);
}

export function initTheme(): void {
  applyTheme(getTheme());
}
